<!--suppress JSUnusedGlobalSymbols -->
<template>
    <main>
        <news-heading :subtitle="true">Latest News</news-heading>
        <news-internal-slide :articles="internals"></news-internal-slide>

        <div class="flex-container">
            <section class="combo combo--2 combo--third" v-if="recipe">
                <a :href="recipe.url">
                    <news-heading :subtitle="true">Recipe of the Week</news-heading>
                    <img :src="recipe.image" :alt="recipe.image_alt">
                    <h2 v-html="recipe.title" class="recipe-title"></h2>
                </a>
            </section>
            <section class="combo combo--2 combo--third" >
                <a :href="recipe.url">
                    <news-heading :subtitle="true">Latest video</news-heading>
                    <iframe :src="`https://www.youtube.com/embed/${videoId}`" frameborder="0" allowfullscreen></iframe>
                </a>
            </section>
            <section class="combo combo--2 combo--third" v-if="destination">
                <a :href="destination.url">
                    <news-heading :subtitle="true">Destination of the day</news-heading>
                    <img :src="destination.image" :alt="destination.image_alt">
                    <h2 v-html="destination.title" class="recipe-title"></h2>
                </a>
            </section>
        </div>

        <news-heading :subtitle="true">Latest Features</news-heading>
        <features-slide :features="features"></features-slide>

        <div class="flex-container">
            <section class="combo combo--1 combo--third">
                <a href="/history-of-palestine">
                    <h2>The History of Palestine</h2>
                    <div class="parallax-image"
                         style="background-image: url(https://www.welcometopalestine.com/wp-content/uploads/2017/04/historyhome.jpg)"></div>
                    <p>Step through the window of time and explore the History of Palestine with our interactive timeline dating
                        from 12500BC – 21st Century.</p>
                </a>
            </section>
            <section class="combo combo--1 combo--third">
                <a href="/getting-in">
                    <h2>Getting In</h2>
                    <div class="parallax-image parallax-image--inverted delay--1"
                         style="background-image: url(https://www.welcometopalestine.com/wp-content/uploads/2017/02/Getting-in-to-Pal-600x300.jpg)"></div>
                    <p>Whether you are travelling to The West Bank or Gaza – follow our extensive guide on the easiest methods
                        of travel to Palestine.</p>
                </a>
            </section>
            <section class="combo combo--1 combo--third">
                <a href="/about">
                    <h2>About Us</h2>
                    <div class="parallax-image delay--2"
                         style="background-image: url(https://www.welcometopalestine.com/wp-content/uploads/2017/03/AttilAbout.jpg)"></div>
                    <p>Come with us and explore the culturally rich, talented and endlessly fascinating Palestine that continues to surprise and amaze everyone who looks a little deeper.</p>
                </a>
            </section>
        </div>
        <div class="the-map">
            <div id="chartdiv"></div>
        </div>
    </main>
</template>

<script>
	import {makeMap} from  "../home/map";
	import axios from "axios";
	import {stripInformation} from "../shared/stripInformation";
	import NewsInternalSlide from "../news/news-internal-slide.vue";
	import FeaturesSlide from "../features/features-slide.vue";
	import NewsHeading from "../news/news-heading.vue";

	export default {
		components: {
			FeaturesSlide,
			NewsInternalSlide,
			NewsHeading
		},
		data () {
			return {
				internalsData: [],
				featuresData: [],
				videoData: [],
				recipeData: null,
				destinationData: null,
			}
		},
		mounted () {
			makeMap();
        },
		created () {
			this.fetchInternals();
			this.fetchFeatures();
			this.fetchRecipe();
			this.fetchDestination();
			this.fetchVideo();
		},
		computed: {
			videoId () {
				if (this.videoData.length) {
					return this.videoData[0].customs.youtube_id[0];
				} else {
					return [];
				}
            },
			internals () {
				if (this.internalsData.length) {
					return stripInformation(this.internalsData);
				} else {
					return [];
				}
			},
            features () {
				if (this.featuresData.length) {
					return stripInformation(this.featuresData);
				} else {
					return [];
				}
            },
            recipe () {
				return this.stripInfo(this.recipeData);
            },
            destination () {
				return this.stripInfo(this.destinationData);
            }
		},
        methods: {
			stripInfo (data) {
				if (data) {
					return {
						url:        data.link,
						title:      data.title.rendered,
						image_alt:  data["_embedded"]["wp:featuredmedia"][0]["media_details"]["alt_text"],
						image:      data["_embedded"]["wp:featuredmedia"][0]["media_details"]["sizes"]["chillnews_mikado_landscape"]["source_url"],
                        categories: data.categories
					}
                } else {
					return null
                }
            },
			fetchInternals () {
				if (window.internalsData) {
					this.internalsData = window.internalsData;
				} else {
					axios.get("/wp-json/news/v1/internals").then(({data}) => {
						this.internalsData = data;
					})
				}
            },
            fetchFeatures () {
				if (window.featuresData) {
					this.featuresData = window.featuresData;
				} else {
					axios.get("/wp-json/home/v1/features").then(({data}) => {
						this.featuresData = data;
					})
				}
            },
            fetchRecipe () {
				if (window.recipeData) {
					this.recipeData = window.recipeData;
				} else {
					axios.get("/wp-json/home/v1/recipe").then(({data}) => {
						this.recipeData = data;
					})
				}
            },
			fetchDestination () {
				if (window.destinationData) {
					this.destinationData = window.destinationData;
				} else {
					axios.get("/wp-json/home/v1/destination").then(({data}) => {
						this.destinationData = data;
					})
				}
			},
			fetchVideo () {
				if (window.videoData) {
					this.videoData = window.videoData;
				} else {
					axios.get("/wp-json/news/v1/videos?amount=1").then(({data}) => {
						this.videoData = data;
					})
				}
			}
        }
	}
</script>

<style lang="scss">
    @import "~foundation-sites/scss/foundation";

    h2.news-title.news-subtitle {
        margin: 0;
    }

    div.swiper-container.news-internal {
        margin: 0;
        margin-bottom: 2rem;
    }

    main,
    .social-container {
        margin: 2rem 0;
        @include breakpoint(medium) {
            margin: 2rem 3rem;
        }
        @include breakpoint(large) {
            margin: 2rem auto;
            max-width: 1290px;
        }
    }

    .flex-container {
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        justify-content: space-between;
        @include breakpoint(small only) {
            padding: 0 1rem;
        }
    }

    .combo--2 img {
        display: block;
    }

    .combo--2 .recipe-title {
        margin: 0;
        padding: 1rem;
        position: absolute;
        bottom: 0;
        width: 100%;
        background: rgba(0,0,0,.5);
        color: white;
    }

    .combo--2 iframe {
        height: calc(100% - 63px);
        width: 100%;
        display: block;
    }

    #chartdiv {
        width: 100%;
        height: 600px;
        max-width: 1200px;
        margin: auto;
        box-shadow: 1px 1px 6px 3px rgba(0, 0, 0, 0.2);
        margin-bottom: 2rem;
        background-image: url("https://www.welcometopalestine.com/wp-content/uploads/2017/04/staticmap.png");
        background-size: cover;
        @media screen and (min-width: 1024px) {
            background-size: contain;
        }
        background-repeat: no-repeat;
        background-position: center center;
        @include breakpoint(small only) {
            width: calc(100% - 2rem);
            margin: 0 1rem;
            margin-bottom: 2rem;
            border-radius: 5px;
        }
    }

    .combo {
        flex: 100%;
        box-shadow: 1px 1px 6px 3px rgba(0, 0, 0, 0.2);
        margin-bottom: 2rem;
        position: relative;
        border-radius: 10px;
        overflow: hidden;
    }

    /* Medium and up */
    @include breakpoint(medium) {
        .combo.combo--first {
            margin-right: 2rem;
        }
        .combo {
            flex: calc(50% - 1rem) 0;
        }
        .combo.combo--third {
            flex: calc(33% - 1rem) 0;
        }
    }


    .combo--1 {
        position: relative;
        height: 60vh;
        @include breakpoint(medium) {
            min-height: 400px;
        }
    }

    .combo--1 h2 {
        margin: 0;
        padding: 1rem;
        padding-top: 2rem;
        background: #292929;
        color: white;
        position: relative;
        z-index: 5;
    }

    .combo--1 .parallax-image {
        &.delay--1 {
            animation-delay: .5s;
        }
        &.delay--2 {
            animation-delay: 1s;
        }
        //-60px cuz looks cool
        background-position: 30% -60px;
        background-repeat: no-repeat;
        background-size: cover;
        height: 100%;
        width: 120%;
        animation: parallax 10s ease infinite alternate;
    }

    .combo--1 .parallax-image.parallax-image--inverted {
        animation-name: parallax-inverted;
    }



    .combo--1 p {
        position: absolute;
        bottom: 0;
        padding: 1rem;
        color: white;
        background: rgba(0,0,0,.4);
        flex: 100%;
        margin: 0;
        font-size: 1.3rem;
    }

    @keyframes parallax {
        0% {
            transform: translate(0,0);
        }
        100% {
            transform: translate(-10%);
        }
    }

    @keyframes parallax-inverted {
        0% {
            transform: translate(-10%);
        }
        100% {
            transform: translate(0,0);
        }
    }

    .combo--full-width {
        flex: 100% 0 0;
    }

    .combo--3 {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        > * {
            flex: 100% 0;
            padding: 1rem;
            @include breakpoint (medium) {
                padding: 1.5rem;
            }
            @include breakpoint (large) {
                flex: 50% 0 0;
            }
        }
        .about-us-content {
            @include breakpoint (large) {
                flex: 60% 0 0;
            }
            p {
                line-height: 2rem;
                margin-top: 0;
                margin-bottom: 1.5rem;
                flex: 100%;
                font-size: 1.3rem;
                @include breakpoint (large) {
                    font-size: 1.6rem;
                    margin-bottom: 2rem;
                }
            }
        }
        .about-us-image {
            @include breakpoint (large) {
                flex: 40% 0 0;
            }
            img {
                width: 100%;
                border-radius: 5px;
                display: block;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// home.vue?5df739ec